import rehabService from '@Apis/rehab.api';
import { RehabQueryChoiceList } from '@Types/rehab.types';
import { AssetTypeId, SystemTypeId } from '@Types/assetSchema.types';

export const getRehabRulesChoiceListApi = (
	systemType: SystemTypeId,
	assetType: AssetTypeId,
	recordType: string,
	inspectionStandard?: string,
	treeId?: string,
) => {
	const address = `/rehabTree/fieldsByRecordType/${recordType}`;
	return rehabService.get<RehabQueryChoiceList>(address, {
		params: {
			systemType: systemType.externalId,
			assetType: assetType.externalId,
			inspectionStandard,
			treeId,
		},
	});
};
